import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-sliding-card',
  templateUrl: './sliding-card.component.html',
  imports: [NgClass, TranslateDirective, TranslatePipe],
})
export class SlidingCardComponent {
  @Output() onCardSelect = new EventEmitter<void>();
  @Input() text: string;
  @Input() id: string;
  @Input() type: 'default' | 'featured' = 'default';
  cardIsFocused = false;

  constructor() {}

  onClick(event): void {
    event.preventDefault();
    this.onCardSelect.emit(event);
  }
}
